import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

/**
 * Toast dos avisos de pendência (PendenciaAvisoService): ícone e cor próprios, o título da
 * pendência em destaque e a chamada para abrir. Os outros toasts do sistema continuam no padrão
 * do ngx-toastr.
 *
 * Herda o comportamento do `Toast` (clique, fechar, sem auto-hide quando pedido): só troca o
 * template. `title` é a frase do acontecimento ("Nova pendência de João"); `message`, o título da
 * pendência. Os dois são texto de usuário: interpolação do Angular, nunca innerHTML.
 */
@Component({
  selector: '[app-pendencia-toast]',
  standalone: true,
  imports: [NgIf],
  templateUrl: './pendencia-toast.component.html',
  styleUrl: './pendencia-toast.component.scss',
  // A mesma animação do Toast padrão: o host liga `@flyInOut` ao estado da base.
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ opacity: 0 })),
      state('active', style({ opacity: 1 })),
      state('removed', style({ opacity: 0 })),
      transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
      transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
    ])
  ],
  preserveWhitespaces: false
})
export class PendenciaToastComponent extends Toast {
  /** O X fecha sem abrir a pendência (o clique no corpo abre). */
  fechar(evento: Event): void {
    evento.stopPropagation();
    this.remove();
  }
}
